
import { defineComponent, ref } from 'vue';
import Heading from '@/components/atoms/Heading.vue';

export default defineComponent({
  name: 'TheDetailPageHeader',
  components: { Heading },
});
